export const imageMap = {
  'Anna.jpg': new URL('../img/team/Anna.jpg', import.meta.url),
  'Blaire.jpg': new URL('../img/team/Blaire.jpg', import.meta.url),
  'Duke.jpg': new URL('../img/team/Duke.jpg', import.meta.url),
  'Ella.jpg': new URL('../img/team/Ella.jpg', import.meta.url),
  'Jane.jpg': new URL('../img/team/Jane.jpg', import.meta.url),
  'Kelly.jpg': new URL('../img/team/Kelly.jpg', import.meta.url),
  'Kikang.jpg': new URL('../img/team/Kikang.jpg', import.meta.url),
  'Kun.jpg': new URL('../img/team/Kun.jpg', import.meta.url),
  'Rachel.jpg': new URL('../img/team/Rachel.jpg', import.meta.url),
  'Sehyun.jpg': new URL('../img/team/Sehyun.jpg', import.meta.url),
  'Taegyun.jpg': new URL('../img/team/Taegyun.jpg', import.meta.url),
  'Yony.jpg': new URL('../img/team/Yony.jpg', import.meta.url),
  'aiden.jpg': new URL('../img/team/aiden.jpg', import.meta.url),
  'alice.jpg': new URL('../img/team/alice.jpg', import.meta.url),
  'byun-og.jpg': new URL('../img/team/byun-og.jpg', import.meta.url),
  'byun.jpg': new URL('../img/team/byun.jpg', import.meta.url),
  'christine.jpg': new URL('../img/team/christine.jpg', import.meta.url),
  'dongmin.png': new URL('../img/team/dongmin.png', import.meta.url),
  'elena.png': new URL('../img/team/elena.png', import.meta.url),
  'ellie.jpg': new URL('../img/team/ellie.jpg', import.meta.url),
  'hyojung.jpg': new URL('../img/team/hyojung.jpg', import.meta.url),
  'ina.jpg': new URL('../img/team/ina.jpg', import.meta.url),
  'jason.jpg': new URL('../img/team/jason.jpg', import.meta.url),
  'jingee.jpg': new URL('../img/team/jingee.jpg', import.meta.url),
  'john.jpg': new URL('../img/team/john.jpg', import.meta.url),
  'jy-og.jpg': new URL('../img/team/jy-og.jpg', import.meta.url),
  'jy.jpg': new URL('../img/team/jy.jpg', import.meta.url),
  'kevin.jpg': new URL('../img/team/kevin.jpg', import.meta.url),
  'kijun-og.jpg': new URL('../img/team/kijun-og.jpg', import.meta.url),
  'kijun.jpg': new URL('../img/team/kijun.jpg', import.meta.url),
  'minhong.jpg': new URL('../img/team/minhong.jpg', import.meta.url),
  'sarah.jpg': new URL('../img/team/sarah.jpg', import.meta.url),
  'scott.jpg': new URL('../img/team/scott.jpg', import.meta.url),
  'suhjin.jpg': new URL('../img/team/suhjin.jpg', import.meta.url),
  'sunny.jpg': new URL('../img/team/sunny.jpg', import.meta.url),
  'ted.jpg': new URL('../img/team/ted.jpg', import.meta.url),
  'youngjoong.png': new URL('../img/team/youngjoong.png', import.meta.url),
  '2.06.jpg': new URL('../img/capstone/2.06.jpg', import.meta.url),
  '3sigma1.gif': new URL('../img/capstone/3sigma1.gif', import.meta.url),
  'aura.png': new URL('../img/capstone/aura.png', import.meta.url),
  'char.png': new URL('../img/capstone/char.png', import.meta.url),
  'cmu-play.png': new URL('../img/capstone/cmu-play.png', import.meta.url),
  'cubs4.png': new URL('../img/capstone/cubs4.png', import.meta.url),
  'dokdo.png': new URL('../img/capstone/dokdo.png', import.meta.url),
  'eco8-2.jpg': new URL('../img/capstone/eco8-2.jpg', import.meta.url),
  'gpt.png': new URL('../img/capstone/gpt.png', import.meta.url),
  'horizon.png': new URL('../img/capstone/horizon.png', import.meta.url),
  'meta2.png': new URL('../img/capstone/meta2.png', import.meta.url),
  'meta_1.jpg': new URL('../img/capstone/meta_1.jpg', import.meta.url),
  'mu_1.png': new URL('../img/capstone/mu_1.png', import.meta.url),
  'mu_2.png': new URL('../img/capstone/mu_2.png', import.meta.url),
  'mun.png': new URL('../img/capstone/mun.png', import.meta.url),
  'nft.webp': new URL('../img/capstone/nft.webp', import.meta.url),
  'nft3.png': new URL('../img/capstone/nft3.png', import.meta.url),
  'resq.png': new URL('../img/capstone/resq.png', import.meta.url),
  'revision.png': new URL('../img/capstone/revision.png', import.meta.url),
  'unison.png': new URL('../img/capstone/unison.png', import.meta.url),
  'xr.png': new URL('../img/capstone/xr.png', import.meta.url),
  'zeta3.png': new URL('../img/capstone/zeta3.png', import.meta.url),
  'bridgelab.png': new URL('../img/sprint/bridgelab.png', import.meta.url),
  'cherry.jpg': new URL('../img/youtube/cherry.jpg', import.meta.url),
  'chris.jpg': new URL('../img/youtube/chris.jpg', import.meta.url),
  'mangotango.png': new URL('../img/youtube/mangotango.png', import.meta.url),
  'techno24.png': new URL('../img/youtube/techno24.png', import.meta.url),
  'techno25.jpg': new URL('../img/youtube/techno25.jpg', import.meta.url),
};